import React, { useState } from 'react'
import {
    makeStyles,
    Typography,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    FormHelperText,
    NativeSelect,
    Button,
} from '@material-ui/core/'
import { Alert } from '@material-ui/lab'
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useHistory, useLocation } from 'react-router-dom';
const useStyles = makeStyles({
    main_card: {
        width: '80%',
        display: 'flex',
        flexDirection: 'column',
        padding: '30px'
    },
    input: {
        marginTop: '15px'
    },
    btn: {
        marginTop: '10px'
    },
    alert: {
        marginBottom: '20px',
    }
})

const RegisterSchema = Yup.object().shape({
    name: Yup.string().required('Campo Obrigatório'),
    email: Yup.string().email('Email inválido').required('Campo obrigatório'),
    tel: Yup.string().required('Campo Obrigatṕrio'),
    gender: Yup.string().required('Campo Obrigatório'),
    age: Yup.number().positive('Idade invalida').integer('formato invalido')
});

export default function PatientForm() {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()
    const [submit, setSubmit] = useState(false)
    const [submitError, setSubmitError] = useState(false)
    const patient = location.state.data


    const onSubmit = async (values) => {
        try {
            const patients = JSON.parse(localStorage.getItem('patients'))
            const updatedPatients = patients.filter(item => item.email !== patient.email)
            updatedPatients.push(values)
            localStorage.setItem('patients', JSON.stringify(updatedPatients))
            //await Professional.register(values)
            setSubmitError(false)
            setSubmit(true)
            //setTimeout(() => history.push("/professional"), 2000)
        }
        catch (err) {
            setSubmitError(true)
        }
    }

    return (
        <>
            <Paper elevation={3} className={classes.main_card}>
                {submit ? (
                    <Alert
                        severity="success"
                        className={classes.alert}>Cadastro realizado com sucesso!
                    </Alert>)
                    : null}
                {submitError ? (
                    <Alert
                        severity="error"
                        className={classes.alert}>Ocorreu um problema ao tentar se comunicar com o servidor
                        , tente novamente!
                    </Alert>)
                    : null}
                <Typography variant='h6'>Editar paciente</Typography>
                <Formik
                    initialValues={{
                        name: patient.name,
                        email: patient.email,
                        tel: patient.tel,
                        gender: patient.gender,
                        age: patient.age
                    }}
                    validationSchema={RegisterSchema}
                    onSubmit={onSubmit}
                >
                    {({ handleChange, handleBlur, handleSubmit, values, errors, touched }) => (
                        <>
                            <TextField
                                error={errors.name && touched.name ? true : false}
                                id="name"
                                label="Nome"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                helperText={
                                    errors.name && touched.name ? (
                                        errors.name
                                    ) : null
                                }
                            />
                            <TextField
                                error={errors.email && touched.email ? true : false}
                                id="email"
                                label="E-mail"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                helperText={
                                    errors.email && touched.email ? (
                                        errors.email
                                    ) : null
                                }
                            />
                            <TextField
                                error={errors.tel && touched.tel ? true : false}
                                id="tel"
                                label="Tel"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.tel}
                                helperText={
                                    errors.tel && touched.tel ? (
                                        errors.tel
                                    ) : null
                                }
                            />
                            <FormControl className={classes.input}
                                error={errors.gender && touched.gender ? true : false}>
                                <InputLabel id="gender">Sexo</InputLabel>
                                <NativeSelect
                                    id="gender"
                                    value={values.gender}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    <option aria-label="None" value="" />
                                    <option value={'Masculino'}>Masculino</option>
                                    <option value={'Feminino'}>Feminino</option>
                                </NativeSelect>
                                <FormHelperText>
                                    {
                                        errors.gender && touched.gender ? (
                                            errors.gender
                                        ) : null
                                    }
                                </FormHelperText>
                            </FormControl>
                            <TextField
                                error={errors.age && touched.age ? true : false}
                                id="age"
                                label="Idade"
                                className={classes.input}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.age}
                                helperText={
                                    errors.age && touched.age ? (
                                        errors.age
                                    ) : null
                                }
                            />


                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.btn}
                                onClick={handleSubmit}
                            >
                                Editar
                            </Button>
                        </>
                    )}
                </Formik>
            </Paper>
        </>
    )
}
